export const toStorePayload = (values: any, editItem: any) => ({
  ...(editItem ? {} : { locationId: values.store?.value }),
  isEnabled: values.isEnabled
})
